import { EyeOff } from "lucide-react";
import { type ReactElement, type ReactNode } from "react";

import { cn } from "../utils/cn";

export interface HiddenBlockProps {
  children: ReactNode;
  className?: string;
}

/** Stands in for content the Anonym-Ansicht hides (#140). Looks the same
 * whether there was anything to hide, so it never hints at a length. */
export function HiddenBlock({ children, className }: HiddenBlockProps): ReactElement {
  return (
    <p
      className={cn(
        "m-0 flex items-center gap-2 rounded-md bg-bg-subtle px-3 py-2 text-sm text-text-secondary",
        className,
      )}
    >
      <EyeOff size={14} aria-hidden="true" className="shrink-0" />
      <span>{children}</span>
    </p>
  );
}
